import React from 'react';

/**
 * SkeletonCard - animated placeholder matching stat card and project card shapes
 * variant: 'stat' | 'project' | 'contractor-mobile'
 */
const SkeletonCard = ({ variant = 'stat', count = 1 }) => {
  const items = Array.from({ length: count }, (_, i) => i);

  if (variant === 'stat') {
    return (
      <>
        {items?.map((i) => (
          <div key={i} className="bg-card rounded-xl p-4 sm:p-5 md:p-6 border border-border animate-pulse">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-lg bg-muted flex-shrink-0" />
              <div className="flex-1">
                <div className="h-3 bg-muted rounded w-24 mb-2" />
                <div className="h-7 bg-muted rounded w-16" />
              </div>
            </div>
            <div className="h-3 bg-muted rounded w-3/4" />
          </div>
        ))}
      </>
    );
  }

  if (variant === 'metrics') {
    return (
      <>
        {items?.map((i) => (
          <div key={i} className="bg-card rounded-xl p-4 sm:p-5 md:p-6 border border-border animate-pulse">
            <div className="flex items-start justify-between mb-4">
              <div className="w-10 h-10 rounded-lg bg-muted" />
              <div className="h-5 bg-muted rounded w-12" />
            </div>
            <div className="h-8 bg-muted rounded w-20 mb-2" />
            <div className="h-3 bg-muted rounded w-32 mb-1" />
            <div className="h-3 bg-muted rounded w-24" />
          </div>
        ))}
      </>
    );
  }

  if (variant === 'project') {
    return (
      <>
        {items?.map((i) => (
          <div key={i} className="bg-card rounded-xl border border-border p-4 md:p-5 animate-pulse">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="h-4 bg-muted rounded w-3/4 mb-2" />
                <div className="h-3 bg-muted rounded w-1/2" />
              </div>
              <div className="h-5 bg-muted rounded-full w-16 ml-2" />
            </div>
            <div className="flex gap-2 mb-3">
              <div className="h-5 bg-muted rounded-full w-20" />
              <div className="h-5 bg-muted rounded-full w-16" />
            </div>
            <div className="h-1.5 bg-muted rounded-full w-full mb-2" />
            <div className="flex items-center justify-between">
              <div className="h-3 bg-muted rounded w-16" />
              <div className="h-3 bg-muted rounded w-12" />
            </div>
          </div>
        ))}
      </>
    );
  }

  if (variant === 'contractor-mobile') {
    return (
      <>
        {items?.map((i) => (
          <div key={i} className="bg-card rounded-xl border border-border p-4 animate-pulse">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-full bg-muted flex-shrink-0" />
              <div className="flex-1">
                <div className="h-4 bg-muted rounded w-32 mb-2" />
                <div className="h-3 bg-muted rounded w-24" />
              </div>
              <div className="h-6 bg-muted rounded-full w-20" />
            </div>
            <div className="flex gap-4 pt-3 border-t border-border">
              <div className="h-3 bg-muted rounded w-28" />
              <div className="h-3 bg-muted rounded w-20" />
            </div>
          </div>
        ))}
      </>
    );
  }

  return null;
};

export default SkeletonCard;
